// Resolves URL filter params to the option objects tables filter by.
// Import-free on purpose — no React, DOM, router or toast — so it runs
// server-side and moves in one piece when filtering goes to the API layer.

// Instagram "posts" -> "likes" (#7012); old links still carry the old label.
const RENAMED_HEALTH_STAT_LABELS = {
    'average weekly posts': 'average weekly likes',
};
const renameHealthStatFilterValue = (value) => {
    const i = value.lastIndexOf('-'); // values are `${label}-${score}`
    if (i === -1) return value;
    const renamed = RENAMED_HEALTH_STAT_LABELS[value.slice(0, i)];
    return renamed ? `${renamed}${value.slice(i)}` : value;
};

export const filterValueRenamers = {
    healthStats: renameHealthStatFilterValue,
};

// `paramValues` is { [filter]: string[] }, already split out of the query
// string. Renames are applied here, so a stale link resolves without a
// redirect; `dropped` reports values that map to nothing.
export const resolveUrlFilters = (
    paramValues,
    accessorsAndOptions,
    renamers = filterValueRenamers,
) => {
    const filters = {};
    const dropped = {};
    Object.entries(paramValues).forEach(([key, values]) => {
        const { accessor, options } = accessorsAndOptions[key] || {};
        if (!accessor || !options) {
            filters[key] = values;
            return;
        }
        const rename = renamers[key];
        filters[key] = values.reduce((acc, value) => {
            const match =
                options.find((o) => accessor(o) === value) ??
                (rename
                    ? options.find((o) => accessor(o) === rename(value))
                    : undefined);
            if (match) acc.push(match);
            // Options can still be loading; nothing is unhonoured until there
            // is something to match against.
            else if (options.length) (dropped[key] ||= []).push(value);
            return acc;
        }, []);
    });
    return { filters, dropped };
};
